@let isAdmin = isLoggedInUserAdmin();
<div class="flex flex-row justify-between items-center gap-y-4 mx-4">
  <div
    class="flex flex-row justify-start py-2 flex-wrap gap-4 w-full items-center"
  >
    @if (targetUnits(); as targetUnits) {
      @if (targetUnits.length > 1) {
        <pm-target-unit-picker />
      }
    }

    @if (latestForecastSeries()) {
      <pm-forecast-resolution />
    }

    @if (
      allAvailableAdditionalTimeSeriesNames() &&
      allAvailableAdditionalTimeSeriesNames()!.length > 0
    ) {
      <pm-additional-time-series-picker />
    }

    @if (availableFilterCombinations().length > 0) {
      <pm-filter-combination-picker queryParamKey="filterCombinationIds" />
    }
    <!-- important note: we always want to display the forecast version picker -->
    <pm-forecast-version-picker />

    @if (validFilters().length > 0) {
      <!-- filters and more in dialog -->
      <pm-button
        variant="outlined"
        text="FILTER.ALL_FILTERS"
        (handleClick)="openFilterDialog()"
        [disabled]="isForecastSeriesFetching()"
      />
    }

    <pm-button
      variant="outlined"
      [matMenuTriggerFor]="menu"
      [disabled]="isForecastSeriesFetching()"
      [icon]="moreIcon"
      dataTestid="forecast-options-menu-button"
    />

    <mat-menu #menu="matMenu">
      <!-- chart options -->
      @if (isChartOptionsEnabled()) {
        <button mat-menu-item (click)="this.openChartOptionsDialog()">
          <span class="inline-flex items-center">
            <pm-icon [icon]="settingsIcon" class="mr-2"></pm-icon>
            <span>{{ 'RESULT.VISIBILITY_OPTIONS.TITLE' | translate }}</span>
          </span>
        </button>
      }

      @if (isAdmin) {
        @if (forecastVersion()?.isVisible) {
          <button
            mat-menu-item
            [disabled]="numberOfVersions === 1"
            (click)="
              updateForecastVersionVisibility(
                false,
                forecastVersion()?.id ?? ''
              )
            "
          >
            <span class="inline-flex items-center">
              <pm-icon [icon]="visibilityOffIcon" class="mr-2"></pm-icon>
              {{ 'RESULT.MAKE_VERSION_INVISIBLE' | translate }}
            </span>
          </button>
        } @else {
          <button
            mat-menu-item
            (click)="
              updateForecastVersionVisibility(true, forecastVersion()?.id ?? '')
            "
          >
            <span class="inline-flex items-center">
              <pm-icon [icon]="visibilityIcon" class="mr-2"></pm-icon>
              {{ 'RESULT.MAKE_VERSION_VISIBLE' | translate }}
            </span>
          </button>
        }
        <!-- logs of selected forecast version -->
        <button mat-menu-item (click)="this.openForecastLogs()">
          <span class="inline-flex items-center">
            <pm-icon [icon]="externalLinkIcon" class="mr-2"></pm-icon>
          </span>
          <span>{{ 'RESULT.SIDEBAR.OPEN_LOGS' | translate }}</span>
        </button>
      }

      <!-- Edit Widget View -->
      @if (isAdmin && insightsFeature().enabled) {
        <button mat-menu-item (click)="openWidgetEditorDialog()">
          <span class="inline-flex items-center">
            <pm-icon [icon]="gridIcon" class="mr-2"></pm-icon>
            {{ 'RESULT.INSIGHTS.GENERAL.OPEN_EDITOR' | translate }}
          </span>
        </button>
      }

      <!-- forecast-details -->
      <button mat-menu-item (click)="this.openForecastDetailsDialog()">
        <span class="inline-flex items-center">
          <pm-icon [icon]="infoIcon" class="mr-2"></pm-icon>
          <span>{{ 'RESULT.SIDEBAR.DESCRIPTION' | translate }}</span>
        </span>
      </button>

      @if (isAdmin) {
        <!-- calculate new forecast version options -->
        <pm-execute-configuration-options [configurationId]="configurationId" />

        <!-- @deprecated This feature is only for temporary use in the Medicos Scenario Planning Light feature and will be removed in the future. -->
        @if (isTmpScenarioPlanningLightProvisionalEnabled()) {
          <button
            mat-menu-item
            (click)="handleTmpScenarioPlanningLightProvisional()"
          >
            <span class="inline-flex items-center">
              <pm-icon [icon]="databaseBackupIcon" class="mr-2"></pm-icon>
              <span>{{ 'MEDICOS.LABEL' | translate }}</span>
            </span>
          </button>
        }

        <!-- delete forecast version -->
        <mat-divider></mat-divider>
        <button
          mat-menu-item
          data-testid="delete-forecast-version-button"
          (click)="openDeleteForecastVersionDialog()"
        >
          <span class="inline-flex items-center">
            <pm-icon [icon]="trashIcon" class="mr-2"></pm-icon>
          </span>
          <span>{{
            'RESULT.SIDEBAR.DELETE_FORECAST_VERSION' | translate
          }}</span>
        </button>
      }
    </mat-menu>
    <pm-button
      variant="primary"
      text="RESULT.KPIS.TITLE_BAR.EXPORT"
      (handleClick)="openExportDialog()"
      [disabled]="isForecastSeriesFetching() || !isExportButtonEnabled()"
      class="ml-auto"
      data-testid="export-forecast-button"
    />
  </div>
</div>
